import { markAsComplete } from '../e-verify/EverifyForm';

let taskCompletedCallback = null;

const receiver = (event) => {
  let data = null;
  try {
    data = JSON.parse(event.data);
    const messageEvent = data.event;
    switch (messageEvent) {
      case 'onSection1Completed':
        markAsComplete('formi9_section1', taskCompletedCallback);
        break;
      case 'onSection2Completed':
      case 'onFormI9Completed':
        markAsComplete('formi9_section2', taskCompletedCallback);
        break;
      default:
        break;
    }
  } catch (error) {
    // error
  }
};

const initReceiver = () => {
  window.removeEventListener('message', receiver);
  window.addEventListener('message', receiver);
};

const removeReceiver = () => {
  window.removeEventListener('message', receiver);
};

const initialize = (onTaskCompleted) => {
  taskCompletedCallback = onTaskCompleted;
  initReceiver();
};

const PostMessage = {
  initialize,
  removeReceiver,
};

export default PostMessage;
